export const BURN_CHART_BAR_COLOR = '#DDE5ED'
export const BURN_CHART_IDEAL_COLOR = '#74EC81'
export const BURN_CHART_REAL_COLOR = '#FF7373'
